export default {
  app: {
    languagePopup: {
      title: 'Du är för närvarande på den engelska versionen av {logo}',
      subtitle: 'Vill du byta till ditt föredragna språk?',
      cta: 'Byt till {lang}',
    },
  },
};
